<template>
    <div>
        <b-container fluid>
            <header-buttons
                    :buttons="headerButtons"
                    @onRequestDelete="deleteRequest"
                    @onRequestGetTicket="downloadTickets"
                    @onAlreadyPaid="alreadyPaid"
                    @onPayNow="() => showModalPayment = true"
            ></header-buttons>
            <b-row>
                <b-col cols="12" class="mb-3">
                    <b-alert show class="text-center shadow" :variant="variantStatus">
                        <p>Stato richiesta:</p>
                        <h3 class="alert-heading text-uppercase">{{labelStatus}}</h3>
                    </b-alert>
                </b-col>
            </b-row>
            <b-row v-if="env !== 'prod' && currentSocietyRequest.status === 'approved'" class="mb-3">
                <b-col cols="12" md="3">
                    <b-card no-body class="text-center" border-variant="success">
                        <b-card-header
                                header-bg-variant="success"
                                header-text-variant="white"
                                class="py-2">VISA
                        </b-card-header>
                        <div class="pt-1 text-center small">Num. 4539970000000006</div>
                        <div class="pb-1 text-center small">Scad. 12/2030</div>
                    </b-card>
                </b-col>
                <b-col cols="12" md="3">
                    <b-card no-body class="text-center" border-variant="danger">
                        <b-card-header
                                header-bg-variant="danger"
                                header-text-variant="white"
                                class="py-2">VISA
                        </b-card-header>
                        <div class="pt-1 text-center small">Num. 4539970000000014</div>
                        <div class="pb-1 text-center small">Scad. 12/2030</div>
                    </b-card>
                </b-col>
                <b-col cols="12" md="3">
                    <b-card no-body class="text-center" border-variant="success">
                        <b-card-header
                                header-bg-variant="success"
                                header-text-variant="white"
                                class="py-2">MASTERCARD
                        </b-card-header>
                        <div class="pt-1 text-center small">Num. 5255000000000001</div>
                        <div class="pb-1 text-center small">Scad. 12/2030</div>
                    </b-card>
                </b-col>
                <b-col cols="12" md="3">
                    <b-card no-body class="text-center" border-variant="danger">
                        <b-card-header
                                header-bg-variant="danger"
                                header-text-variant="white"
                                class="py-2">MASTERCARD
                        </b-card-header>
                        <div class="pt-1 text-center small">Num. 5255000000000019</div>
                        <div class="pb-1 text-center small">Scad. 12/2030</div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
        <society-matches-request-details
                :key="societyMatchesRequestDetailsKey"
                :sectorBusySeats="sectorBusySeats"
                :sectorTotalSeats="sectorTotalSeats"
                :juniorTickets="juniorTickets.length"
                :seniorTickets="seniorTickets.length"
                :requestStatus="{variant: variantStatus, label: labelStatus}"
                :extraJunior="extraJunior"
                :matchRequest="currentSocietyRequest">
        </society-matches-request-details>
        <hr>
        <b-container fluid>
            <b-row>
                <b-col cols="12" class="mb-3">
                    Di seguito, trovi l'elenco dei biglietti compresi nella tua richiesta. Clicca su una card per rimuoverla.
                    Ricorda che il numero degli adulti deve sempre essere minore o uguale al numero dei minori.
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6">
                    <b-row>
                        <b-col>
                            <h3 class="text-primary text-uppercase my-0">
                                Biglietti per accompagnatori
                            </h3>
                        </b-col>
                    </b-row>
                    <hr>
                    <b-row v-if="currentSocietyRequest.status === constant.REQUEST_STATUSES.pending.name">
                        <b-col>
                            <inter-button class="mb-3 mx-auto"
                                          label="Aggiungi Accompagnatore"
                                          @onClick="showModalAddTicket(constant.CONTACT_SENIOR)">
                            </inter-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-3"
                               v-for="(contact, index) in seniorTickets" v-bind:key="index" cols="12" md="6">
                            <society-contact-container
                                    :confirmText="`Sei sicuro di voler rimuovere ${contact.surname} ${contact.name}`"
                                    confirmTitle="Rimuovi biglietto"
                                    @onClick="removeTicket"
                                    :confirmAction="confirmRemoveTicket"
                                    :contact="contact"></society-contact-container>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" md="6">
                    <b-row>
                        <b-col>
                            <h3 class="text-primary text-uppercase my-0">
                                Biglietti per atleti
                            </h3>
                        </b-col>
                    </b-row>
                    <hr>
                    <b-row v-if="currentSocietyRequest.status === constant.REQUEST_STATUSES.pending.name">
                        <b-col>
                            <inter-button class="mb-3 mx-auto"
                                          label="Aggiungi Atleta"
                                          @onClick="showModalAddTicket(constant.CONTACT_JUNIOR)">
                            </inter-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-3"
                               v-for="(contact, index) in juniorTickets" v-bind:key="index" cols="12" md="6">
                            <society-contact-container
                                    confirmTitle="Rimuovi biglietto"
                                    :confirmText="`Sei sicuro di voler rimuovere ${contact.surname} ${contact.name}`"
                                    @onClick="removeTicket"
                                    :confirmAction="confirmRemoveTicket"
                                    :contact="contact"></society-contact-container>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <inter-modal :title-icon="iconModal"
                         :buttonPrimary="buttonPrimary"
                         :title="titleModal"
                         :visible="showModal"
                         @onPrimaryClick="addTickets()">
                <society-matches-add-contact-container
                        ref="societyMatchesAddContactContainer"
                        :mode="modeModal"
                        :availability="sectorAvailableSeats"
                        :juniorAuthorized="extraJunior"
                        :contacts="contatsToAdd">
                </society-matches-add-contact-container>
            </inter-modal>

            <inter-modal title-icon="flaticon-euro"
                         title="Paga ora"
                         :visible="showModalPayment">
                <society-matches-request-payment
                    @onUploaded="showModalPayment = false"
                    :match-request="currentSocietyRequest"/>
            </inter-modal>

        </b-container>
    </div>
</template>

<script>

    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import {mapGetters, mapMutations, mapActions} from 'vuex';
    import Utils from "@/utils";
    import CONST from "@/const";
    import TicketService from "@/services/ticket-service";
    import SocietyContactContainer from "../../society-contacts/components/contact-container/SocietyContactContainer";
    import InterButton from "../../../components/form/inter-button/InterButton";
    import InterModal from "../../../components/modal/InterModal";
    import SocietyMatchesAddContactContainer
        from "../components/society-matches-add-contact-container/SocietyMatchesAddContactContainer";
    import Contact from '@/models/Contact';
    import SocietyMatchesRequestDetails
        from "../components/society-matches-request-details/SocietyMatchesRequestDetails";
    import _ from "lodash";
    import SocietyMatchesRequestPayment
        from "@/modules/society-matches/components/society-matches-request-payment/SocietyMatchesRequestPayment.vue";

    export default {
        name: "SocietyDashView",
        components: {
            SocietyMatchesRequestPayment,
            SocietyMatchesRequestDetails,
            SocietyMatchesAddContactContainer,
            InterModal,
            InterButton,
            SocietyContactContainer,
            HeaderButtons,
        },
        data() {
            return {
                sectorBusySeats: 0,
                sectorTotalSeats: 0,
                showModal: false,
                titleModal: '',
                iconModal: '',
                modeModal: '',
                showModalPayment: false,
                buttonPrimary: {
                    label: 'Aggiungi',
                    confirm: true
                },
                constant: CONST,
                societyMatchesRequestDetailsKey: 1,
                contatsToAdd: [],
                contactToRemove: Object.assign({}, Contact),
                env: process.env.VUE_APP_ENV,
                enableReupload: false,
                buttonUpload: {
                    label: 'Carica un altro file',
                    confirm: true
                },
                file: {},
                response: {}
            }
        },
        computed: {
            dropzoneOptions: function () {
                return {
                    url: process.env.VUE_APP_API_URL + '/api/v1/media/upload/distinta-bonifico',
                    headers: {
                        "client": process.env.VUE_APP_OAUTH_CLIENT_NAME,
                        "Authorization": 'Bearer ' + this.accessToken
                    },
                    renameFile:"Distinta Bonifico",
                    acceptedFiles: "application/pdf",
                    createImageThumbnails: false
                }
            },
            ...mapGetters(['currentSocietyRequest']),

            sectorAvailableSeats: function () {
                return this.sectorTotalSeats - this.sectorBusySeats;
            },

            extraJunior: function () {
                return (this.seniorTickets.length - (this.juniorTickets.length * this.currentSocietyRequest.match.adult_vs_childs)) / this.currentSocietyRequest.match.adult_vs_childs;
            },

            labelStatus: function () {
                const statusSetting = Utils.getRequestStatusSettings(this.currentSocietyRequest.status);
                return statusSetting ? statusSetting.label : 'N.D.';
            },

            variantStatus: function () {
                const statusSetting = Utils.getRequestStatusSettings(this.currentSocietyRequest.status);
                return statusSetting ? statusSetting.variant : 'N.D.';
            },

            juniorTickets: function () {
                return TicketService.getJuniorTickets(this.currentSocietyRequest.details);
            },

            seniorTickets: function () {
                return TicketService.getSeniorTickets(this.currentSocietyRequest.details);
            },

            headerButtons: function () {
                let buttons = [];

                if (this.currentSocietyRequest.status === CONST.REQUEST_STATUSES.pending.name) {
                    buttons.push({
                        label: 'Elimina Richiesta',
                        confirm: true,
                        onClick: 'onRequestDelete'
                    });

                    buttons.push({
                        label: 'Paga ora',
                        confirm: false,
                        onClick: 'onPayNow'
                    });
                }

                if (this.isAvailableTickets) {
                    buttons.push({
                        label: 'Scarica biglietti',
                        confirm: true,
                        onClick: 'onRequestGetTicket'
                    });
                }

                return buttons;
            },

            confirmRemoveTicket: function () {
                return this.currentSocietyRequest.status === CONST.REQUEST_STATUSES.pending.name;
            },

            isEnablePayment: function () {
                return this.currentSocietyRequest.status === CONST.REQUEST_STATUSES.pending.name;
            },

            isEnableRemove: function () {
                return this.currentSocietyRequest.status === CONST.REQUEST_STATUSES.pending.name;
            },

            isAvailableTickets: function () {
                return (this.currentSocietyRequest.status === CONST.REQUEST_STATUSES.completed.name) &&
                    this.currentSocietyRequest.media.length !== 0;
            },
        },

        mounted() {

            this.tickets = _.find(this.currentSocietyRequest.media, {tag: 'tickets'});


            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
                this.showModalPayment = false;
            });

            this.setBreadcrumbActive(
                Utils.setDateFormatITA(this.currentSocietyRequest.match.date)
                + ' - ' + this.currentSocietyRequest.match.opponent
            );

            this.societyMatchesGetSectorAvailability({
                idMatch: this.currentSocietyRequest.match.id,
                idSector: this.currentSocietyRequest.sector.id,
            }).then((data) => {
                this.sectorBusySeats = data.busy;
                this.sectorTotalSeats = data.total;
            }).catch();

        },
        methods: {

            ...mapMutations([
                'setBreadcrumbActive'
            ]),

            ...mapActions({
                societyMatchesGetSectorAvailability: 'societyMatchesGetSectorAvailability',
                societyMatchesGetContactAvailability: 'societyMatchesGetContactAvailability',
                societyMatchesAddTicketRequest: 'societyMatchesAddTicketRequest',
                societyMatchesRemoveTicketFromRequest: 'societyMatchesRemoveTicketFromRequest',
                societyMatchesGetPaymentUrl: 'societyMatchesGetPaymentUrl',
                societyMatchesDeleteRequest: 'societyMatchesDeleteRequest',
                commonDownloadFile: 'commonDownloadFile',
                societyMatchesRequestAlreadyPaid: 'societyMatchesRequestAlreadyPaid',
            }),

            showModalAddTicket: function (mode) {
                if (this.currentSocietyRequest.status === CONST.REQUEST_STATUSES.pending.name) {
                    this.modeModal = mode;
                    if (mode === CONST.CONTACT_JUNIOR) {
                        this.titleModal = 'Aggiungi Atleta';
                        this.iconModal = 'flaticon-baby'
                    } else {
                        this.titleModal = 'Aggiungi Accompagnatore';
                        this.iconModal = 'flaticon-employee'
                    }

                    this.societyMatchesGetContactAvailability({
                        idMatch: this.currentSocietyRequest.match.id,
                        mode: mode
                    }).then((data) => {
                        this.contatsToAdd = data;
                        this.showModal = true;
                    }).catch();
                }
            },

            addTickets: function () {

                if (this.$refs.societyMatchesAddContactContainer.validate()) {
                    this.societyMatchesAddTicketRequest({
                        id: this.currentSocietyRequest.id,
                        contacts: this.$refs.societyMatchesAddContactContainer.selected
                    }).then(() => {
                        this.$bvToast.toast('Richiesta aggiornata correttamente', {
                            title: 'Success',
                            variant: 'success'
                        });
                        this.showModal = false;
                        this.societyMatchesRequestDetailsKey += 1;
                    }).catch(() => {
                        this.$bvToast.toast('Biglietti non aggiunti', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                        this.showModal = false;
                    });
                } else {
                    this.$bvToast.toast('Il numero degli adulti deve essere minore o uguale al numero degli under18', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }

            },

            removeTicket: function (contact) {
                if (this.isEnableRemove) {
                    this.societyMatchesRemoveTicketFromRequest({
                        id: this.currentSocietyRequest.id,
                        idContact: contact.id
                    }).then(() => {
                        this.$bvToast.toast('Richiesta aggiornata correttamente', {
                            title: 'Success',
                            variant: 'success'
                        });
                        this.societyMatchesRequestDetailsKey += 1;
                    }).catch(() => {
                        this.$bvToast.toast('Biglietti non rimosso', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    });
                }
            },

            deleteRequest: function () {
                if (this.isEnableRemove) {
                    this.societyMatchesDeleteRequest(this.currentSocietyRequest)
                        .then(() => {
                            this.$bvToast.toast('Richiesta rimossa correttamente', {
                                title: 'Success',
                                variant: 'success'
                            });
                            this.$router.push({name: 'society.matches'})
                        }).catch(() => {
                        this.$bvToast.toast('Richiesta non rimossa', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    });
                } else {
                    this.$bvToast.toast('Stato richiesta non corretto', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }
            },

            downloadTickets: function () {
                this.commonDownloadFile({
                    url: this.tickets.url,
                    filename: this.tickets.filename +
                        '.' + this.tickets.extension,
                    auth: true
                }).then()
                    .catch(() => {
                        this.$bvToast.toast('Problema download', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    })
            },

            alreadyPaid: function () {
                if(this.currentSocietyRequest.status === this.constant.REQUEST_STATUSES.pending.name && _.isEmpty(this.response)){
                    this.$bvToast.toast('Carica la distinta bonifico per seganalare come pagata', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }else{
                    let data = this.currentSocietyRequest;
                    data.media = this.response;
                    this.societyMatchesRequestAlreadyPaid(data)
                        .then(() => {
                            this.$refs.uploadBonifico.removeAllFiles();
                            this.response = {};
                            this.file = {};
                            this.$bvToast.toast('Avviso inoltrato correttamente', {
                                title: 'Success',
                                variant: 'success'
                            });
                        }).catch(() => {
                        this.$bvToast.toast('Avviso non inoltrato', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    });
                }
            }


        }
    }
</script>

<style scoped>
    #uploadBonifico {
    background-color: #ffdc3c;
    min-height: 15px;
    padding: 0px 25px 0px 25px;
    }
</style>
